module.exports = __webpack_public_path__ + "img/logo-hj.dae5ff16.png";